export default class Default {
  constructor(main, shopify) {
    this.u = main.utils;
    this.s = shopify;

    //Default ajax settings
    this._defaults = shopify._ajax_defaults;
  }

  
  getAll(opts) {
    var url      = `/admin/products.json`;
    var settings = $.extend({}, this._defaults);
    var data     = $.extend(true, {}, opts.data);

    $.extend(true, settings, {
      url : url,
      data : JSON.stringify(data),
      method : 'GET',
      success : (d) => {
        if(typeof(opts.callback) == 'function') opts.callback(d);
      },
    });

    //Call url
    $.ajax(settings);
  }

  
  search(opts) {
    var url      = '/search?view=json';
    var settings = $.extend({}, this._defaults);
    var data     = $.extend(true, {}, opts.data);

    $.extend(true, settings, {
      url : url,
      data : data,
      method : 'GET',
      dataType: 'json',
      success : (d) => {
        if(typeof(opts.callback) == 'function') opts.callback(d);
      },
    });

    //Call url
    $.ajax(settings);
  }

  
  collection(opts) {
    var url      = `/collections/${opts.handle}`;
    var settings = $.extend({}, this._defaults);
    var data     = $.extend(true, {view:'json'}, opts.data);

    $.extend(true, settings, {
      url : url,
      data : data,
      method : 'GET',
      dataType: 'html',
      success : (d) => {
        var json = JSON.parse(d);
        if(typeof(opts.callback) == 'function') opts.callback(json);
      },
    });

    //Call url
    $.ajax(settings);
  }

  
  getByHandle(opts) {
    var url      = `/products/${opts.handle}.js`;
    var settings = $.extend({}, this._defaults);
    var data     = $.extend(true, {}, opts.data);

    $.extend(true, settings, {
      url : url,
      data : JSON.stringify(data),
      method : 'GET',
      success : (d) => {
        if(typeof(opts.callback) == 'function') opts.callback(d);
      },
    });

    //Call url
    $.ajax(settings);
  }

  
  getByID(opts) {
    var url      = `/admin/products/${opts.id}.json`;
    var settings = $.extend({}, this._defaults);
    var data     = $.extend(true, {}, opts.data);

    $.extend(true, settings, {
      url : url,
      data : JSON.stringify(data),
      method : 'GET',
      success : (d) => {
        if(typeof(opts.callback) == 'function') opts.callback(d);
      },
    });

    //Call url
    $.ajax(settings);
  }
}